export default __webpack_public_path__ + "static/media/img_scsc_15.b44c0ce3.png";